import { PropsWithChildren } from "react";
import { Card, CardContent, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, styled, Typography } from "@mui/material";
import theme from "../app/app-theme";
import { CheckCircleOutlineIcon } from "../shared/icons";

// const navBarHeight = 64;

// const GridRoot = styled(Grid)(({ theme }) => ({
//     display: 'flex',
//     minHeight: `calc(100vh - ${navBarHeight}px)`,
//     margin: 'auto',
//     textAlign: 'center',
// }));

const GridBanner = styled(Grid)(({ theme }) => ({
    backgroundColor: `${theme.palette.primary.main}`,
    height: '100px',
    fontSize: '24px',
    color: `${theme.palette.secondary.light}`,
    fontWeight: 'bold',
    padding: '1rem',
}));

const FeatureList = styled(List)(({ theme }) => ({
    color: 'grey',
    '& .MuiListItem-root': {
        paddingTop: 0,
        paddingBottom: 0
    }
}));

const CardWrapper = styled(Grid)(({ theme }) => ({
    padding: '1rem',
    cursor: 'auto',
    [theme.breakpoints.up('md')]: {
        height: '100%',
    }
}));

const StyledCard = styled(Card)(({ theme }) => ({
    // height: '430px',
    border: `${theme.palette.success.main} solid 1px`,
    '& .MuiCardActionArea-root': {
        '&:hover': {
            transform: "scale3d(1.05, 1.05, 1)"
        }
    }
}));


interface PackageCardProps {
    readonly title: string
    readonly description: string
    readonly amount: string
    readonly unit: string
    // readonly icon: string
}

function PackageCard({ title, children, description, amount, unit }: PropsWithChildren<PackageCardProps>) {
    return <CardWrapper size={{ lg: 3, md: 4, sm: 12, xs: 12 }} >
        <StyledCard elevation={2}>
            <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" component="p">
                    {description}
                </Typography>
                <Typography variant="h3" sx={{ color: `${theme.palette.primary.main}` }} component="p">
                    {amount}
                </Typography>
                <Typography variant="h6" sx={{ color: `${theme.palette.primary.main}` }} component="p">
                    {unit}
                </Typography>
                <Divider style={{ marginBottom: "20px" }} />
                {children}
            </CardContent>
        </StyledCard>
    </CardWrapper>
}

export default function Pricing() {
    return (
        <div>
            <Grid container direction="row" justifyContent="flex-start" alignItems="center" >
                <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }} >
                    <div className="text-center">
                        <GridBanner container direction="row" justifyContent="center" alignItems="center" >
                            Simple Pricing for Every Fitness Center
                        </GridBanner>
                        <Grid container direction="row" justifyContent="center" sx={{ textAlign: 'center' }}>
                            {/* <Grid container direction="row" justifyContent="center" alignItems="center"> */}
                            <PackageCard title="Free"
                                description="For startups and small fitness centers"
                                amount="0"
                                unit="LKR/Month">
                                <FeatureList>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="10 Members" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="2 Free Accounts" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="20 Free Messages" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="Mobile App" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="SMS Notifications" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="Automated Payment Reminders" sx={{ color: "black" }} />
                                    </ListItem>
                                </FeatureList>
                            </PackageCard>
                            <PackageCard title="Pro"
                                description="For any scale fitness centers"
                                amount="30"
                                unit="LKR/Member/Month">
                                <FeatureList>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="Unlimited Members" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="5 Free Accounts" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="200 Free Messages" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="Mobile App" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="SMS Notifications" sx={{ color: "black" }} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                        <ListItemText primary="Automated Payment Reminders" sx={{ color: "black" }} />
                                    </ListItem>
                                </FeatureList>
                            </PackageCard>
                            {/* <PackageCard title="Standard"
                            description="For medium-scale fitness centers"
                            amount="50"
                            unit="LKR/Member/Month">
                            <FeatureList>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="Unlimited Members" sx={{color: "black"}} />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="10 Free Accounts" sx={{color: "black"}} />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="400 Free Messages" sx={{color: "black"}} />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="Mobile App" sx={{color: "black"}} />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="SMS Notifications" sx={{color: "black"}} />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutlineIcon color="success" /></ListItemIcon>
                                    <ListItemText primary="Automated Payment Reminders" sx={{color: "black"}} />
                                </ListItem>
                            </FeatureList>
                        </PackageCard> */}
                            {/* </Grid> */}
                        </Grid>
                    </div>
                    <div className="text-center" style={{ marginTop: '2rem' }}>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}